import { ColBreakpoints, Cols, Spacing, SpacingBreakpoints } from './interfaces';
import styles from './grid.module.scss';

const breakpointsArray: (keyof ColBreakpoints)[] = ['sm', 'md', 'lg', 'xl'];

export const generateColClassNames = (prefix: string, breakpoints?: ColBreakpoints | SpacingBreakpoints) =>
    breakpointsArray.reduce(
        (classNames, breakpoint) => {
            const value = breakpoints?.[breakpoint];
            return {
                ...classNames,
                [styles[`${prefix}-${breakpoint}-${value}`]]: value,
            };
        },
        {} as { [key: string]: Cols | Spacing | undefined },
    );
